import React from "react";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ToastifyService } from "../../../services";
import {
  translationConstants,
  paymentConstants,
  paymentType,
} from "../../../constants";

const SavedCardForm = (props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const { t } = useTranslation();

  const onSubmit = (data) => {
    if (!props.totalFee) {
      ToastifyService.showError(t(translationConstants.INVALID_TOTAL_AMOUNT));
    } else {
      if (props.type === paymentType.Freelance) {
        props.dispatch({
          systemUserId: props.systemUserId,
          spotId: props.spotId,
          sportIds: props.sportIds,
          fee: props.totalFee.toFixed(2),
          cardId: data.selectedCard,
        });
      } else if (props.type === paymentType.Membership) {
        props.dispatch({
          systemUserId: props.systemUserId,
          fee: props.totalFee.toFixed(2),
          cardId: data.selectedCard,
        });
      } else if (props.type === paymentType.Event) {
        props.dispatch({
          systemUserId: props.systemUserId,
          eventId: props.eventId,
          fee: props.totalFee.toFixed(2),
          status: 0,
          cardId: data.selectedCard,
        });
      } else if (props.type === paymentType.Competition) {
        if (props.selectedBoatClass) {
          props.dispatch({
            systemUserId: props.systemUserId,
            competitionId: props.eventId,
            fee: props.totalFee.toFixed(2),
            status: 0,
            cardId: data.selectedCard,
            genderBoatClassId: props.selectedBoatClass,
          });
        } else {
          props.setBoatClassError(
            t(translationConstants.COMPETITION_BOAT_CLASS_REQUIRED)
          );
        }
      } else if (props.type === paymentType.Center) {
        props.dispatch({
          centerId: props.centerId,
          fee: props.totalFee.toFixed(2),
          cardId: data.selectedCard,
        });
      }
    }
  };

  return (
    <Form noValidate onSubmit={handleSubmit(onSubmit)} className="pt-4">
      <Form.Group className="form-group">
        <Form.Label>{t(translationConstants.SELECT_CARD)}:</Form.Label>
        <Form.Select
          className="custom-select-icon"
          {...register("selectedCard", {
            required: t(translationConstants.PAYMENT_CARD_IS_REQUIRED),
          })}
        >
          <option value="">
            {t(translationConstants.PLEASE_SELECT_A_CARD)}
          </option>
          {props.savedCards &&
            props.savedCards?.map((card) => (
              <option key={card.id} value={card.id}>
                {paymentConstants.CARD_NUMBER_MASK + card.last4Digits}
              </option>
            ))}
        </Form.Select>
        {errors?.selectedCard && (
          <p className="errorText pb-2">{errors?.selectedCard?.message}</p>
        )}
      </Form.Group>

      <Form.Group
        className="d-flex justify-content-space-between pt-4 pb-2"
        controlId="formBasicCheckbox"
      >
        <Form.Check
          className="custom-checkbox custom-checkboxInput"
          type="checkbox"
          {...register("paymentRegulations", {
            required: t(translationConstants.PAYMNET_REGULATION_REQUIRED),
          })}
        />
        <div className="font-12">
          {t(translationConstants.AGREE_TO_TERMS)}{" "}
          <a className="center-card-view-detail-link approved-color cursor-not-allowed">
            {t(translationConstants.PAYMENT_REGULATIONS)}
          </a>
        </div>
      </Form.Group>
      {errors?.paymentRegulations && (
        <p className="errorText pb-2">{errors?.paymentRegulations?.message}</p>
      )}

      <div className="py-2">
        <Button className="Login-button w-50" type="submit">
          {t(translationConstants.PAY_NOW)}
        </Button>
      </div>
    </Form>
  );
};

export default SavedCardForm;
